define([
	"dojo/_base/declare",
	"dijit/_Container",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/_Widget",
	"dijit/form/_FormMixin",
	"./_DialogValues"
], function(declare,_Container,_TemplatedMixin,_WidgetsInTemplateMixin,_Widget,_FormMixin,_DialogValues) {

	return declare([_Widget, _TemplatedMixin,_WidgetsInTemplateMixin, _Container, _FormMixin], {
		// Boolean: when set/get values from the widget, verify that the checkbox exists before converting value to/from internal format
		//verifyCheckBoxExistence: false,

		_setValueAttr: function(value) {
			var w = this.verifyCheckBoxExistence ? this : null;
			this.inherited(arguments, [_DialogValues.internalizeValues(value, w)]);
		},

		_getValueAttr: function() {
			var w = this.verifyCheckBoxExistence ? this : null;
			return _DialogValues.externalizeValues(this.inherited(arguments), w);
		},

		focus: function() {
		}
	});
});